import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import EmailTemplate from "@mapmycustomers/shared/types/email/EmailTemplate";
import { DYNAMIC_VAR_REGEX } from "@mapmycustomers/ui";

import getDynamicVarVariants from "@app/util/fieldModel/util/getDynamicVarVariants";

import EmailView from "../EmailView";

import styles from "./TemplateView.module.scss";

interface TemplateViewProps {
  template: EmailTemplate;
}

const TemplateView: React.FC<TemplateViewProps> = ({ template }) => {
  const intl = useIntl();

  const body: string = useMemo(() => {
    const [dynamicVarVariants] = getDynamicVarVariants(intl, template.entityType, []);
    return template.body.replace(DYNAMIC_VAR_REGEX, (...args) => {
      const groups: NonNullable<RegExpMatchArray["groups"]> = args[args.length - 1];
      const prefix = args[1];
      const fieldName = groups["fieldName"];

      const dynamicVarVariant = dynamicVarVariants.find(
        (dynamicVarVariant) =>
          prefix === dynamicVarVariant.prefix && dynamicVarVariant.name === fieldName
      );

      return dynamicVarVariant
        ? `<span class="dynamicVarVariant">${dynamicVarVariant.displayName}</span>`
        : "";
    });
  }, [intl, template]);

  return <EmailView body={body} className={styles.emailView} subject={template.subject} />;
};

export default TemplateView;
